module.exports = {"630103001":"人民街街道","630103002":"南滩街道","630103003":"仓门街街道","630103004":"礼让街街道","630103005":"饮马街街道","630103006":"南川东路街道","630103007":"南川西路街道","630103100":"总寨镇","630103400":"南川工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630103.json
// module id = 3119
// module chunks = 0